import { CircleHelp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MAIN_ID } from '~/components/SkipLink'
import { Button } from '~/components/ui/button'

function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <main id={MAIN_ID} className="w-full h-dvh bg-background flex flex-col justify-center items-center gap-6">
      <CircleHelp width={48} height={48} />
      <h1 className="font-bold font-primary">
        {t('not.found.message')}
      </h1>
      <Button className="rounded-lg px-4 py-2" type="button" onClick={() => navigate('/')}>
        {t('common.back')}
      </Button>
    </main>
  )
}

export default NotFound
